// Custom function which toggles between sticky class (is-sticky)
let stickyToggle = function (sticky, stickyWrapper) {
    let stickyHeight = sticky.offsetHeight;
    let stickyTop = stickyWrapper.getBoundingClientRect().top;
    let setSticky = (stickyTop < 0);

    if (setSticky) {
        sticky.classList.add("is-sticky");
        stickyWrapper.style.height = stickyHeight + 'px';
    } else {
        sticky.classList.remove("is-sticky");
        stickyWrapper.style.height = 'auto';
    }
};


document.querySelectorAll('[data-bs-toggle="sticky-onscroll"]')
    .forEach(sticky => {
        let stickyWrapper = document.createElement('div');
        stickyWrapper.classList.add('sticky-wrapper');

        sticky.before(stickyWrapper);

        sticky.classList.add('sticky');

        window.addEventListener('scroll', () => {
            stickyToggle(sticky, stickyWrapper);
        });

        window.addEventListener('resize', () => {
            stickyToggle(sticky, stickyWrapper);
        });

        new ResizeObserver(() => {
            stickyToggle(sticky, stickyWrapper);
        }).observe(sticky)

        stickyToggle(sticky, stickyWrapper);
    });
